/* global i18n */
import ApplicationController from "application_controller.js";
import intlTelInput from "intl-tel-input/intlTelInputWithUtils";
import { el as greek, en as english } from "intl-tel-input/locale";
import axios from "axios";
import get from "lodash/get";

export default class extends ApplicationController  {
  debug = false;

  static values = {
    config: { type: Object, default: {} },
  };

  static targets = [ "main", "country", "mobile", "mobile_valid", "mobile_type" ];

  initialize() {
    this.log_function("initialize");

    let uiTranslations = {};
    let countryNameOverrides = {};
    switch (i18n.locale) {
      case "en":
        uiTranslations = english;
        countryNameOverrides = { ax: "Aland Islands" };
        break;
      case "el":
        uiTranslations = greek;
        break;
      default:
        console.error(`${i18n.locale} is not suported in our implementation of intl_tel_input yet.`);
        break;
    }

    this.boundInitialCountryLookup = this.initialCountryLookup.bind(this);
    this.mainTarget.setAttribute("autocomplete", "tel-national");

    this.instance = intlTelInput(
      this.mainTarget,
      {
        initialCountry: this.countryTarget.value || "auto",
        initialCountryLookup: this.boundInitialCountryLookup,
        separateDialCode: true,
        showFlags: true,
        numberDisplayFormat: "INTERNATIONAL",
        formatAsYouType: false,
        countryOrder: this.countryOrder,
        countryNameLocale: i18n.locale,
        uiTranslations,
        countryNameOverrides,

        ...this.configValue,
      },
    );

    this.boundUpdateCountry = this.update_country.bind(this);
    this.mainTarget.addEventListener("countrychange", this.boundUpdateCountry);

    this.update_country();
  }

  update_country(){
    this.log_function("update_country");

    this.countryTarget.value = this.countryData?.iso2 || "";
    this.update_valid();
    this.update_type();
  }

  update_number() {
    this.log_function("update_number");

    this.mobileTarget.value = `+${this.countryData?.dialCode} ${this.mainTarget.value}`;
    this.update_valid();
    this.update_type();
  }

  update_valid(){
    this.log_function("update_valid");

    this.mobile_validTarget.value = this.instance.getValidationError();
  }

  update_type(){
    this.log_function("update_type");

    this.mobile_typeTarget.value = this.instance.getNumberType();
  }

  async initialCountryLookup(){
    this.log_function("initialCountryLookup");

    try {
      const response = await axios.get("https://api.ipdata.co", {
        params: { "api-key": window._ipdata_api_key },
      });
      this.log_function("initialCountryLookup", response);

      return get(response, "data.country_code", this.default_country_code);
    } catch(error) {
      this.log_error_function("initialCountryLookup", error);

      return this.default_country_code;
    }
  }

  disconnect(){
    this.log_function("disconnect");

    this.instance.destroy();
    this.mainTarget.removeEventListener("countrychange", this.boundUpdateCountry);
  }

  get countryOrder(){
    const countryData = intlTelInput.getAllCountries();
    //* Sort the objects based on dialCode, then iso2
    const sortedObjects = countryData.sort((a, b) => {
      //* First, compare based on dialCode
      const dialCodeComparison = parseInt(a.dialCode) - parseInt(b.dialCode);
      if (dialCodeComparison !== 0) {
        return dialCodeComparison;
      }
      return a.iso2.localeCompare(b.iso2); //* If dialCode is equal, compare based on iso2
    });

    const iso2Codes = sortedObjects.map(obj => obj.iso2); //* Extract iso2 codes from sorted objects

    return iso2Codes;
  }


  get default_country_code(){
    this.log_function("get default_country_code");

    return "gr";
  }

  get countryData(){
    this.log_function("get countryData");
    return this.instance.getSelectedCountry();
  }
}
